export const SET_IS_NOTIFIED = '@app/SET_IS_NOTIFIED';
export const GET_USER = '@app/GET_USER';
export const GET_USER_SUCCESS = '@app/GET_USER_SUCCESS';
export const GET_USER_FAIL = '@app/GET_USER_FAIL';
export const SIGN_UP = '@app/SIGN_UP';
export const SIGN_UP_SUCCESS = '@app/SIGN_UP_SUCCESS';
export const SIGN_UP_FAIL = '@app/SIGN_UP_FAIL';

export interface User {
  id: string;
  email: string;
}

export interface UserFormData {
  firstName: string;
  lastName: string;
  email: string;
}

export interface AppState {
  isNotified: boolean;
  isLoading: boolean;
  user?: User;
  showSignUpError?: boolean;
}
